// frameworks
import Vue from 'vue'

// libs common to projet
import 'bootstrap'
import Toastr from 'toastr'
import Swal from 'sweetalert2'
import popper from 'popper.js'
import tippy, {animateFill} from 'tippy.js';

//variables
window.jQuery = window.$ = jQuery
window.Vue = Vue
window.Popper = popper
window.tippy = tippy
window.animateFill = animateFill
window.Swal = Swal
window.Toastr = Toastr

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.BASE_URL = window.location.protocol + "//" + document.domain + "/";

/**
 * Register CSRF Token
 */
let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    throw('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

import {
    ValidationProvider,
    ValidationObserver,
    extend,
    configure,
    setInteractionMode,
} from "vee-validate";

setInteractionMode("dirtyValidate", ({ errors }) => {
    if (errors.length) {
        return {
            on: ["change"],
        };
    }

    return {
        on: ["dirty", "change"],
    };
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

import { dict } from "./vuejs/validation/dictionary";
import { required, required_if, email, min, max, min_value, max_value } from "vee-validate/dist/rules";
extend("required", required);
extend("required_if", required_if);
extend('email', email);
extend("min", min);
extend("max", max);

extend("min_value", {
    ...min_value,
    message: (fieldName, placeholders) => {
        return `Veuillez rentrer une valeur supérieure à ${placeholders.min}`;
    }
});
extend("max_value", {
    ...max_value,
    message: (fieldName, placeholders) => {
        return `Veuillez rentrer une valeur inférieure à ${placeholders.max}`;
    }
});

const mobileRegex = /^(\+33|0)\s*[6-7]([\s.\/-]*\d{2}){4}$/;
extend("mobileNumber", {
    validate: value => mobileRegex.test(value),
    message: () => `Veuillez entrer un numéro de téléphone portable valide.`
});

extend("emailOrPhone", {
    validate: value => {
        return mobileRegex.test(value) || email.validate(value)
    },
    message: () => `Veuillez entrer un numéro de téléphone portable valide ou une adresse email valide.`
});

extend("exists", async card_number => {
    try {
        const response = await axios.get('/client/card_number/'+card_number)
        return response.data.valid ? response.data.valid : response.data.message;
    } catch (error) {
        return "Une erreur s'est produite, veuillez vérifier votre numéro de carte"
    }
});

extend("uniqueEmail", async value => {
    try {
        const response = await axios.get('/client/email/'+value)
        return response.data.valid ? response.data.valid : response.data.message;
    } catch (error) {
        return "Une erreur s'est produite, veuillez vérifier votre email"
    }
});

extend("belongsTo", async (value, [target]) =>{
    if (target === '') return "Veuillez saisir un numéro de carte"

    try {
        const response = await axios.get('/client/card_number/'+target+'?belonger='+value)
        return response.data.valid ? response.data.valid : response.data.message;
    } catch (error) {
        return "Une erreur s'est produite"
    }
});

extend("emailAndPhonePair", async (value, [target]) =>{
    if (target === '') return "Veuillez renseigner l'autre champ"

    try {
        const response = await axios.get(`/client/email_phone?values[]=${value}&values[]=${target}`)
        return response.data.valid ? response.data.valid : response.data.message;
    } catch (error) {
        return "Une erreur s'est produite"
    }
});

configure({
    defaultMessage: (field, values) => {
        return dict[field] !== undefined ? dict[field][values._rule_] : false
    },
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});

import ValidationInput from "./vuejs/validation/ValidationInput";
import ValidationCheckbox from "./vuejs/validation/ValidationCheckbox";
import ValidationSelect from "./vuejs/validation/ValidationSelect";

window.ValidationSelect = ValidationSelect
window.ValidationInput = ValidationInput
window.ValidationCheckbox = ValidationCheckbox

/* methods to format numbers */
Vue.filter("euros_format", function (str) {
    let formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    let formattedNumber = formatter.format(str);
    return formattedNumber.replace(/\u00A0/g, " ");
})
Vue.filter("number_format", function (str) {
    return new Intl.NumberFormat('fr-FR').format(str)
})
